import { NavigationService } from 'app/shared/services';
import { forkJoin } from 'rxjs';

import { inject } from '@angular/core';

import { NotificationsService } from './layout/common/notifications/notifications.service';
import { ShortcutsService } from './layout/common/shortcuts/shortcuts.service';

export const initialDataResolver = () => {
  //const messagesService = inject(MessagesService);
  const navigationService = inject(NavigationService);
  const notificationsService = inject(NotificationsService);
  //const quickChatService = inject(QuickChatService);
  const shortcutsService = inject(ShortcutsService);

  // Fork join multiple API endpoint calls to wait all of them to finish
  return forkJoin([
    navigationService.get(),
    //messagesService.getAll(),
    notificationsService.getAll(),
    //quickChatService.getChats(),
    shortcutsService.getAll(),
  ]);
};
